import { Box, Typography } from '@mui/material';
import React from 'react';

import { FlexGrid, FlexRow } from '../../../../../common/components/v2';
import { Resource } from '../../../../../common/constants/resource';
import { Dispute } from '../../../../tasks/types/dispute';
import { ReasonsSummary } from '../../ReasonsSummary';
import styles from '../../styles.module.scss';

export const DisputeSummary = ({ dispute }: { dispute: Dispute }) => {
  return (
    <FlexGrid>
      <FlexRow>
        <label className={styles.EvidenceTitle}>
          {Resource.TASK_TITLE_DISPUTE}
        </label>
      </FlexRow>
      <Box mt={2}>
        <Typography variant="body1" gutterBottom>
          {Resource.DESCRIPTION}
        </Typography>
      </Box>
      <Box>
        <Typography variant="body2">
          {Resource.TASK_DESCRIPTION_DISPUTE}
        </Typography>
      </Box>
      <ReasonsSummary title={Resource.ORDER_REASON} reasons={dispute.reason} />
    </FlexGrid>
  );
};
